<template>
  <ui-component-modal
    :modalTitle="$t('Components.Articles.ModalCreateArticle.Modal_Title')"
    :isSaving="isSaving"
    :isSavingSuccess="isSavingSuccess"
    :isSavingError="isSavingError"
    :hideFooterButtons="isSavingError || isSavingSuccess"
    :onClickCancel="onClickCancel"
    :onClickSave="createArticle"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <ui-base-input-field
        v-model="newArticle.Title"
        :error="TitleErrors"
        :showLabel="false"
        fieldType="text"
        @input="$v.newArticle.Title.$touch()"
        @blur="$v.newArticle.Title.$touch()"
        @keyup.enter="createArticle"
      />
    </template>
  </ui-component-modal>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import articleProvider from '@/providers/article'
import { required, minLength } from 'vuelidate/lib/validators'
const touchMap = new WeakMap()

export default {
  components: {},

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },

    articleType: {
      type: String,
      default: 'Post',
    },
  },

  data() {
    return {
      isSaving: false,
      isSavingSuccess: false,
      isSavingError: false,
      locationId: Number(this.$route.params.locationId),
      newArticle: null,
    }
  },

  /**
   * Form validation rules
   */
  validations() {
    let output = {
      Title: {
        required,
        minLength: minLength(2),
      },
    }
    return {
      newArticle: output,
    }
  },

  computed: {
    ...mapState('articleStore', ['articlesPageState']),
    ...mapState('locationStore', ['locationState']),

    TitleErrors() {
      const errors = []
      if (!this.$v.newArticle.Title.$dirty) return errors
      !this.$v.newArticle.Title.required &&
        errors.push(this.$t('Form.InputErrors.Required'))
      !this.$v.newArticle.Title.minLength &&
        errors.push(this.$t('Form.InputErrors.minLength', { minLength: 2 }))
      return errors
    },
  },

  created() {
    let tags = []
    tags.push(this.locationState.Name)
    tags.push(this.locationState.City)

    this.newArticle = {
      Type: 'Location',
      ItemId: this.locationId,
      ArticleType: this.articleType,
      Title: '',
      Short: '',
      Text: '',
      Tags: tags.join(','),
    }
  },

  mounted() {
  },

  methods: {
    ...mapMutations('articleStore', ['setArticlesPageState']),
    ...mapMutations('articleStore', ['setArticle']),

    createArticle() {
      let self = this

      if (!self.isSaving) {
        self.isSaving = true
        this.$v.$touch()
        if (this.$v.$invalid) {
          // 'ERROR'
          self.isSaving = false
        } else {
          articleProvider.methods
            .createLocationArticle(this.newArticle)
            .then((response) => {
              if (response.status === 200) {
                self.isSavingSuccess = true
                self.setArticle(response.data)

                let pageState = JSON.parse(
                  JSON.stringify(self.articlesPageState)
                )
                pageState.articles.unshift(response.data)
                self.setArticlesPageState(pageState)

                let t = setTimeout(() => {
                  self.$router.push({
                    name: 'articles-list-edit',
                    params: {
                      key: response.data.Key,
                    },
                  })

                  self.onClickCancel()
                  clearTimeout(t)
                }, 1500)
              }
            })
            .catch((error) => {
              //console.log(error.response)
              self.isSavingError = true
            })
            .finally(() => {
              self.isSaving = false
            })
        }
      }
    },
  },
}
</script>
